import { format, isValid } from 'date-fns';

const formatDeliveryTime = (date) =>
  isValid(date) && format(date * 1000, 'HH:mm');

export default formatDeliveryTime;
